(() => {
  return;

  // eslint-disable-next-line no-unreachable
  document.addEventListener('click', (e) => {
    const elem = window.swinger.eventHub.getTarget(e);

    if (!elem.closest('[href="#swinger-usermenu-item-1"]')) {
      return;
    }

    const target = document.querySelector('#swinger-usermenu-item-1');
    target.focus({ preventScroll: true });

    e.preventDefault();
  }, true);
})();
